export { default } from './AvatarNamePlate'
